var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.className,
           _vm.reverseRowClassName,
           _vm.alignItemsCenter],attrs:{"data-test":_vm.className}},[_c('div',{class:_vm.leftSideClassName},[_vm._t("side")],2),_c('div',{class:_vm.rightSideClassName},[_c('div',[_vm._t("heading")],2),_c('div',[_vm._t("content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }